import BaseRequest from './BaseRequest';

export default class WaiverAgreements extends BaseRequest {
    /**
     * WaiverAgreements constructor
     * 
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(requestMode = 'customer', providerId = '', customerId = '', auth = true, fowardRequest = false) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('WaiverAgreements');
        this.setEndpoint('waiver_agreements');
    }

    /**
     * @param {integer} id
     * @return {object}
     */
    async download(id) {
        let request = new HTTPRequest(
            'GET',
            `${this.getEndpoint()}/${id}/download`,
            this.getHeaders()
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'download',
                {'id': id}
            );
        }

        return await request.sendRequest();
    }
}